module.exports = __webpack_public_path__ + "img/bm.bm728fd21.svg";